import { axios } from '@/services/axios';

const deleteCustomSIPHeader = async (customHeaderID, currentScope) => {
    const res = await axios.delete(`/TRECustomHeader/${customHeaderID}`, {
        headers: {
            'X-RequestScope': currentScope,
        },
    });
    return res.data;
};

export default deleteCustomSIPHeader;
